import { i18n } from '/vodalys/vvuejs/vue.js'
import { flattenLocales } from './translate25localeLoader.mjs'

// Fonction de chargement des locales sans logique de hachage
export async function loadDynamicLocales() {
    for (const locale of Object.keys(flattenLocales)) {
        const response = await fetch(`/vt/${locale}`)
        const text = await response.text()
        const json = JSON.parse(text)
        
        if (process.env.NODE_ENV !== 'production') {
            console.log('json', json)
        }

        i18n.mergeLocaleMessage(locale, json)
    }
}

// Exposer la fonction de chargement en production
globalThis.__loadDynamicLocales = loadDynamicLocales

// Exécution initiale du chargement des locales dans tous les environnements
loadDynamicLocales();

// Logique de rechargement uniquement en développement
if (process.env.NODE_ENV !== 'production') {
    // Fonction de hachage uniquement en développement
    const hashString = async (str) => {
        const encoder = new TextEncoder();
        const data = encoder.encode(str);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
    };

    let lastHash = {};

    // Fonction de rechargement avec vérification de hash
    const reloadDynamicLocales = () => {
        Object.keys(flattenLocales).forEach(async locale => {
            const response = await fetch(`/vt/${locale}`)
            const text = await response.text()
            
            const hash = await hashString(text)
            if (lastHash[locale] === hash) {
                console.log('skip reload v17 locale', locale, hash)
                return
            }
            lastHash[locale] = hash
            console.log('reload v17 locale', locale, hash)
            
            const json = JSON.parse(text)
            console.log('json', json)
            
            i18n.mergeLocaleMessage(locale, json)
        })
    };

    // Exposer la fonction de rechargement en développement
    globalThis.__reloadDynamicLocales = reloadDynamicLocales;

    // Configuration de l'intervalle de rechargement
    const relaodIntervalinSeconds = (JSON.parse(localStorage.getItem('translate25reloadInterval')) || 120)
    setInterval(reloadDynamicLocales, 1000 * relaodIntervalinSeconds);
}

// Hot Module Replacement for i18n
if (module.hot) {
    module.hot.accept();
}